import { Component, OnInit, Input,
    Output, EventEmitter,
    ViewEncapsulation,
} from '@angular/core';
import {
    trigger, state, style,
    animate, transition, keyframes
} from '@angular/animations';

@Component({
    selector: 'jui-modal',
    template: `

      <div class="jui-modal-container" (click)="overlayClicked()"
          *ngIf="isOpen" [@appear]="'in'">
          <div class="modal-locator">
              <div class="main-container" (click)="stopBubble($event)"
                  [ngStyle]="boxStyle">
                  <div class="modal-inner">
                      <ng-content></ng-content>
                  </div>
              </div>
          </div>
      </div>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      .jui-modal-container {
        position: fixed;
        z-index: 1100;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        outline: 0;
        color: #292b2c;
        background: rgba(48, 48, 48, 0.8);
        text-align: center;
        transition: opacity .5s; }
        .jui-modal-container .modal-locator {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          text-align: center;
          max-height: 90%;
          overflow: hidden;
          display: flex; }
          .jui-modal-container .modal-locator .main-container {
            background: #fff;
            padding: 10px 0;
            display: flex;
            border-radius: 4px;
            box-shadow: -6px 6px 10px #444;
            margin: 0px auto; }
            .jui-modal-container .modal-locator .main-container .modal-inner {
              overflow-y: auto;
              overflow-x: hidden;
              width: 100%; }
    `],
    // encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('appear', [
            state('in', style({
                transform: 'translateY(0) scale(1)',
                opacity: 1
            })),
            transition(':enter', [
                animate('400ms ease-in', keyframes([
                    style({opacity: 0, transform: 'translateY(-70%) scale(0.2)', offset: 0}),
                    style({opacity: 0.5, transform: 'translateY(10%) scale(1.2)', offset: 0.3}),
                    style({opacity: 1, transform: 'translateY(0) scale(1)', offset: 1.0})
                ]))
            ]),
            transition(':leave', [
                animate('200ms ease-in', keyframes([
                    style({opacity: 1, transform: 'translateY(0) scale(1)', offset: 0}),
                    style({opacity: 0, transform: 'scale(1.4)', offset: 1.0})
                ]))
            ]),
        ]),
    ]
})
export class ModalComponent implements OnInit {
    @Input()
    public set isOpen(open: boolean) {
        if (this._isOpen === open) {
            return;
        }
        this._isOpen = open;
    }
    public get isOpen() {
        return this._isOpen;
    }
    @Output()
    public isOpenChange = new EventEmitter<boolean>();

    @Input()
    public overlayClosable = true;
    @Input()
    public boxStyle: any;

    private _isOpen = false;
    constructor() {
        // pass
    }

    public ngOnInit() {
        // pass
    }
    public dismiss() {
        this.isOpen = false;
        this.isOpenChange.emit(false);
    }
    public overlayClicked() {
        if (this.overlayClosable) {
            this.dismiss();
        }
    }
    public stopBubble(event) {
        event.stopPropagation();
    }
}
